import React from 'react';
import {
  Edit,
  SimpleForm,
  BooleanInput,
  DateInput,
  FormDataConsumer,
  Toolbar,
  SaveButton,
  useUpdate,
} from 'react-admin';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
} from '@material-ui/core';

const UserEditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton />
  </Toolbar>
);

export const UserEdit = (props) => {
  const { onClose, open, record } = props;
  const [update] = useUpdate();

  const handleClose = () => {
    onClose();
  }

  const handleUnblockButton = () => {
    const data = { is_blocked: false };
    update('users', record.id, data)
    onClose();
  }

  const dateValidation = (value) => {
    const now = Date.now();
    const parsedValue = Date.parse(value);
    return !parsedValue || now + 86400000 > parsedValue;
  }

  const validateForm = (values) => {
    const errors = {};
    if (!values.permanently && dateValidation(values.expire_block)) {
      errors.expire_block = "Expire block invalid";
    }
    return errors;
  }

  const transform = data => {
    const { permanently, ...rest } = data;
    return {
      ...rest,
      is_blocked: true,
    }
  };

  const now = Date.now();
  let userBlockDate;
  if (record.expire_block) {
    userBlockDate = Date.parse(record.expire_block);
  }
  let isBlocked = record.is_blocked;
  if (userBlockDate) {
    isBlocked = userBlockDate > now;
  }

  return (
    <Dialog onClose={handleClose} open={open}>
      {!isBlocked
        ? <Edit
            transform={transform}
            resource="users"
            basePath="/users"
            id={record.id}
          >
            <SimpleForm
              toolbar={<UserEditToolbar />}
              validate={validateForm}
            >
              <BooleanInput
                label="Block permanently"
                source="permanently"
              />
              <FormDataConsumer>
                {({ formData, ...rest }) => (
                  <DateInput
                    disabled={formData.permanently}
                    source="expire_block"
                    {...rest}
                  />
                )}
              </FormDataConsumer>
            </SimpleForm>
          </Edit>
        : <>
            <DialogTitle id="alert-dialog-title">{`Do you really want to unblock '${record.nick_name}'?`}</DialogTitle>
            <DialogActions>
              <Button onClick={handleUnblockButton} color="secondary">
                Unblock
              </Button>
            </DialogActions>
          </>
      }
      
    </Dialog>
  );
};